import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { baseQueryWithAuth } from 'queries';

// initialize an empty api service that we'll inject endpoints into later as needed
export const mainApi = createApi({
    baseQuery: baseQueryWithAuth,
    tagTypes: [
        'Monitor','MonitorsShort', 'Monitors', 'MonitorRunsResultCard', 
        'MonitorRunsCount', 'MonitorRunsGrouped', 'MonitorRunsResultCard', 'LocationTips',
        'HostServices',
        'PropertySpy'
    ],
    reducerPath: 'mainApi',
    endpoints: () => ({}),
})